/**
 * Compound library evidence-stage filter.
 *
 * Plain show/hide filtering: clicking a chip marks it active and hides any
 * compound card whose data-evidence doesn't match (the "all" chip clears
 * the filter). No page reload, no fetch — everything's already rendered,
 * this just toggles the `hidden` attribute.
 */
class CompoundLibraryFilter extends HTMLElement {
  connectedCallback() {
    this.chips = Array.from(this.querySelectorAll('.compound-library__filter-chip'));
    this.grid = this.closest('.compound-library')?.querySelector('.compound-library__grid');
    if (!this.grid) return;

    this.cards = Array.from(this.grid.querySelectorAll('.compound-card'));

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => this.#applyFilter(chip));
    });
  }

  #applyFilter(activeChip) {
    this.chips.forEach((chip) => chip.classList.toggle('is-active', chip === activeChip));

    const filter = activeChip.dataset.filter;
    this.cards.forEach((card) => {
      const matches = filter === 'all' || card.dataset.evidence === filter;
      card.hidden = !matches;
    });
  }
}

if (!customElements.get('compound-library-filter')) {
  customElements.define('compound-library-filter', CompoundLibraryFilter);
}
